module.exports = __webpack_public_path__ + "01_short_gray.cb7af129.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/01_short_gray.png
// module id = kzgs
// module chunks = 0